import { AudioLines } from 'lucide-react'
import { MediaConvertPanel } from '@/features/media/media-convert-panel'
import { convertAudio, type AudioFormat } from '@cloudtools/wasm'
import { replaceExtension } from '@/lib/format'

const AUDIO_FORMATS: readonly { value: AudioFormat; label: string }[] = [
  { value: 'mp3', label: 'MP3 (MPEG Layer 3)' },
  { value: 'wav', label: 'WAV (lossless PCM)' },
  { value: 'aac', label: 'AAC (Advanced Audio Coding)' },
]

/** Audio conversion flow wired to the FFmpeg.wasm worker. */
export function AudioPanel() {
  return (
    <MediaConvertPanel
      accept={['.mp3', '.wav', '.aac', '.m4a']}
      maxSizeMB={200}
      icon={AudioLines}
      formats={AUDIO_FORMATS}
      defaultFormat="mp3"
      convert={(file, format, callbacks) => convertAudio({ input: file, ...callbacks }, format)}
      makeOutputName={(name, format) => replaceExtension(name, format)}
    />
  )
}
